/**
 * Reine Ableitungen fürs direkte Abhaken (B4) und Entfernen (C2) eines To-dos
 * aus der Übersicht bzw. der Detail-Todokarte (Review F2). Bewusst DOM-frei
 * (`.ts`-Modul), damit der node-only Vitest-Runner sie prüft — VorgangTodosCard
 * (Detail) und VorgaengeMo (Übersicht) teilen dieselbe Logik, statt sie doppelt
 * inline zu führen. Spiegelt `toggledManualStatus`/`statusMode` (overviewHead.ts)
 * auf die To-do-Ebene.
 */

/** Erledigt-Konvention: exakt der String 'Erledigt' (freier Status-Text). */
export function istTodoErledigt(status?: string | null): boolean {
    return String(status ?? "").trim() === "Erledigt";
}

/**
 * Ziel-Status beim Klick auf den Erledigt-Kreis eines To-dos (B4): erledigt ⇄
 * offen. Rück-Klick öffnet das To-do wieder.
 */
export function toggledTodoStatus(status?: string | null): "Offen" | "Erledigt" {
    return istTodoErledigt(status) ? "Offen" : "Erledigt";
}

/**
 * Sichtbarkeit der Aktion „To-do entfernen" (C2): nur mit Schreibrecht auf dem
 * Vorgang. Das Backend gatet zusätzlich (DELETE /todo/:id → @Rels delete /
 * mayChange), die UI-Sichtbarkeit folgt dem Karten-`canEdit`.
 */
export function canRemoveTodo(canEdit: boolean): boolean {
    return canEdit === true;
}
